import request from '../helpers/request';

const paymentDomains = {};

paymentDomains.list = async () => {
    return request.get('/payment-domains', {}, true);
};

paymentDomains.getActive = async () => {
    return request.get('/payment-domains/active', {}, false);
};

paymentDomains.add = async (data) => {
    return request.post('/payment-domains/add', data, true);
};

paymentDomains.edit = async (data) => {
    return request.put('/payment-domains/edit', data, true);
};

paymentDomains.setActive = async (id) => {
    return request.put('/payment-domains/set-active', {id}, true);
};

paymentDomains.delete = async (id) => {
    return request.delete('/payment-domains/delete', {id}, true);
};

export default paymentDomains;



